


















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import SearchInput from "@/components/SearchInput.vue";
import BackButton from "@/components/BackButton.vue";
import JobListCard from "@/components/Admin/JobListCard.vue";
import JobModal from "@/components/Admin/JobModal.vue";

import { jobService } from "@/services/job.service";
import { Job } from '@/models/job.model';

import { Resources } from "@/shared/resources";

@Component({
    filters:{
        shortenStr(value:string){
            if(value !== null)
                return value.substring(0,18);
        },
        dateFormat(value:string){
            if(value != null){
            var date = value.split("T");
            return date[0];
            }
            // return value.substring(0,value.indexOf('T'));
        },
        scheduleTypeText(value:any){
            return value == 1 ? Resources.scheduleType.once : value == 2 ? Resources.scheduleType.week : value == 3 ? Resources.scheduleType.month : "";
        }
    },
    components : {
        SearchInput,
        BackButton,
        JobListCard,
        JobModal
    }
})
export default class AdminJob extends Vue{
    filterOnce:boolean = true;
    filterWeek:boolean = true;
    filterMonth:boolean = true;
    doneJobs:boolean = true;
    isModalVisible:boolean = false;
    searchQuery:string = "";

    jobs: Job[] = [];
    jobId:number = 0;


    async created(){
        this.load();
    }

    async load(){
        this.jobs = await jobService.getAll(this.$store.getters["app/companyId"]);

        // console.log(this.jobs);
    }

    edit(id:number){
        this.isModalVisible = true;
        this.jobId = id;
    }

    async remove(id:number){
        this.jobId = id;
        var r = confirm("Sure you want to delete?");
        if (r == true) {
            jobService.delete(id).then(() => {
                this.load();
                this.$notify({
                    group: 'message',
                    title: 'Succe!',
                    text: 'Jobb borttaget',
                    duration: 5000,
                    type: 'success',
                });
            });
        }
    }

    get filteredList(){
        var filterList:Job[] = [];

        if(this.filterOnce){
            this.jobs.filter(j => j.schedule!.scheduleType == 1).forEach(element => {
                // filterList.splice(filterList.indexOf(element),1);
                filterList.push(element);
            })
        }

        if(this.filterWeek){
            this.jobs.filter(j => j.schedule!.scheduleType == 2).forEach(element => {
                // filterList.splice(filterList.indexOf(element),1);
                filterList.push(element);
            })
        }

        if(this.filterMonth){
            this.jobs.filter(j => j.schedule!.scheduleType == 3).forEach(element => {
                // filterList.splice(filterList.indexOf(element),1);
                filterList.push(element);
            })
        }

        if(this.searchQuery != "" && this.searchQuery.length > 1){
            filterList = filterList.filter(c => 
            c.name!.toLowerCase().includes(this.searchQuery.toLowerCase()) 
            || c.category!.name!.toLowerCase().includes(this.searchQuery.toLowerCase())
            || c.cardNames!.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
            // if(filterList.length == 0)
            //     filterList = this.jobs.filter(c => c.user!.firstName!.toLowerCase().startsWith(this.searchQuery.toLowerCase()));
            // if(filterList.length == 0)
            //     filterList = this.jobs.filter(c => c.user!.lastName!.toLowerCase().startsWith(this.searchQuery.toLowerCase()));
        }


        return filterList;
    }


    openModal(){
        this.isModalVisible = true;
        this.jobId = 0;
    }

    modalEvent(obj:any,id:any){
        this.isModalVisible = obj == "close" || obj == "saved" ? false : true;
        this.jobId = id != undefined ? id : this.jobId;
        if(obj == "saved")
            this.load();
    }
}
